export default "__VITE_ASSET__CWFZ_8QV__"